module.exports = require("./lodash.js");


//////////////////
// WEBPACK FOOTER
// lodash (bower component)
// module id = 1391
// module chunks = 1